import * as yup from "yup";
import { InferType } from "yup";
import i18n from "@/i18n";

const postalCode = /^[0-9a-zA-Z]{3}\s?[0-9a-zA-Z]{3}$/;
const bankCode = /^[0-9]{5,5}$/;
const transitNumber = /^[0-9]{3,3}$/;
const accountNumber = /^[0-9]{7,12}$/;
const phone = /^(\+\d\d?)?(\s?[0-9]\s?){10,10}$/;

export const PadAccountSchema = yup.object({
  bankAccountNumber: yup
    .string()
    .matches(accountNumber, {
      message: i18n.t("Account number must contain 7-12 digits", {
        ns: "paymentMethods",
      }),
    })
    .required(),
  bankAccountName: yup.string().default(""),
  field_bankCode: yup
    .string()
    .matches(
      bankCode,
      i18n.t("Bank code must contain 5 digits", {
        ns: "paymentMethods",
      })
    )
    .required(),
  field_bankBranchCode: yup
    .string()
    .matches(transitNumber, {
      message: i18n.t("Transit number must contain 3 digits", {
        ns: "paymentMethods",
      }),
    })
    .required(),
  field_streetNumber: yup.string().required(),
  field_streetName: yup.string().required(),
  field_email: yup
    .string()
    .email(
      i18n.t("Must be a valid email address", {
        ns: "paymentMethods",
      })
    )
    .required(),
  field_postalCode: yup
    .string()
    .matches(postalCode, {
      message: i18n.t("Postal code must be of the form A1B 2C3", {
        ns: "paymentMethods",
      }),
    })
    .required(),
  field_state: yup
    .string()
    .min(
      1,
      i18n.t("State must be provided", {
        ns: "paymentMethods",
      })
    )
    .required(),
  field_city: yup
    .string()
    .min(
      1,
      i18n.t("City must be provided", {
        ns: "paymentMethods",
      })
    )
    .required(),
  field_passthrough4: yup.string().default(""),
  field_passthrough5: yup.string().default(""),
  field_passthrough6: yup.string().default(""),
});

export type PadAccountSchemaType = InferType<typeof PadAccountSchema>;

export const EditPadAccountSchema = yup.object({
  accountHolderInfo: yup
    .object({
      addressLine1: yup.string().default(""),
      addressLine2: yup.string().default(""),
      email: yup
        .string()
        .email(
          i18n.t("Must be a valid email address", {
            ns: "paymentMethods",
          })
        )
        .required(),
      zipCode: yup
        .string()
        .matches(postalCode, {
          message: i18n.t("Postal code must be of the form A1B 2C3", {
            ns: "paymentMethods",
          }),
        })
        .required(),
      state: yup
        .string()
        .min(
          1,
          i18n.t("State must be provided", {
            ns: "paymentMethods",
          })
        )
        .required(),
      city: yup
        .string()
        .min(
          1,
          i18n.t("City must be provided", {
            ns: "paymentMethods",
          })
        )
        .required(),
      phone: yup
        .string()
        .test(
          "test-phone",
          i18n.t("Phone number must be of the form 123 456 7890", {
            ns: "paymentMethods",
          }),
          (value) => value?.length === 0 || phone.test(value || "")
        )
        .default(""),
    })
    .required(),
  defaultPayment: yup.boolean().default(false),
  nickname: yup.string().default(""),
});

export type EditPadAccountSchemaType = InferType<typeof EditPadAccountSchema>;
